"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOauth2Params = exports.getOauth2ClientFailure = exports.getOauth2ClientSuccess = exports.getOauth2ClientRequest = void 0;
const ActionTypes = require("../../actionTypes/auth/oauth2");
const getOauth2ClientRequest = (params) => ({
    type: ActionTypes.GET_OAUTH2_CLIENT_REQUEST,
    payload: params
});
exports.getOauth2ClientRequest = getOauth2ClientRequest;
const getOauth2ClientSuccess = (params) => ({
    type: ActionTypes.GET_OAUTH2_CLIENT_SUCCESS,
    payload: params
});
exports.getOauth2ClientSuccess = getOauth2ClientSuccess;
const getOauth2ClientFailure = (params) => ({
    type: ActionTypes.GET_OAUTH2_CLIENT_FAILURE,
    payload: params
});
exports.getOauth2ClientFailure = getOauth2ClientFailure;
const setOauth2Params = (params) => ({
    type: ActionTypes.SET_OAUTH2_PARAMS,
    payload: params
});
exports.setOauth2Params = setOauth2Params;
//# sourceMappingURL=oauth2.js.map